import { CloseRounded, ContactPage, Info } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import ElectricCarIcon from "@mui/icons-material/ElectricCar";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import HomeIcon from "@mui/icons-material/Home";
import MenuIcon from "@mui/icons-material/Menu";
import PaymentsIcon from "@mui/icons-material/Payments";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Grid, Link, styled, Tab, Tabs, Typography } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Toolbar from "@mui/material/Toolbar";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { useContext, useEffect, useState } from "react";

import { primary } from "../constants/theme";
import { Context } from "../context/context";
import { MemoizedWhatsAppDrawer } from "../Drawer/whatsappDrawer";
import { MemoizedButton } from "../SDK/button";
import { sendAnalytics } from "../utils/analyticsCommon";
import { createCookieInHour } from "../utils/cookie";
import { useMobile } from "../utils/findViewport";
import { leadActions } from "../utils/leadActions";

import StoreIcon from "@mui/icons-material/Store";
import { ActiveItemValue } from "../context/navbarContext";
import { MemoizedWhatsAppPopup } from "../Popups/whatsAppPopup/whatsAppPopup";
import { imagesWEBP } from "../constants/webpImages";

const CustomAppBar = styled(Box)(({ hello, scrollWithPage }) => ({
  display: hello ? "none" : "block",
  minHeight: { xs: "64px", md: "74px" },
  position: "inherit",
  ".container": {
    flex: 1,
    display: "flex",
    alignItems: "center",
  },
  ".toolbar": {
    padding: 0,
    flex: 1,
    justifyContent: "space-between",
    minHeight: "74px",
  },
  ".getoffer": {
    fontSize: "16px",
    lineHeight: "1%",
    textAlign: "center",
    color: primary.white,
    border: `1.5px solid ${primary.white}`,
    borderRadius: "146.7px",
    padding: "18px 24px",
  },
  ".navItems": {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "1.7em",
    color: "#333333",
    textTransform: "none",
    width: "120px",
    "&.active": {
      color: primary.main,
      fontWeight: "700",
    },
  },

  ".MuiTabs-indicator": {
    backgroundColor: primary.white,
    bottom: "5px",
  },
  ".MuiTabs-flexContainer": {
    minHeight: "74px",
  },
  ".icons-mobile": {
    display: "flex",
    alignItems: "center",
  },
  ".MuiSvgIcon-fontSizeLarge": { fontSize: "2em" },

  ".image-section": {
    objectFit: "contain",
    width: "100% !important",
    position: "relative !important",
    cursor: "pointer"
  },
}));

const drawerWidth = "60%";
const navItems = [
  {
    id: 0,
    name: "Home",
    link: "/",
    icon: <HomeIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 1,
    name: "Vehicles",
    link: "/electric-commercial-vehicles",
    icon: <ElectricCarIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 2,
    name: "Referral",
    link: "/referral",
    icon: <GroupAddIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 3,
    name: "Finance",
    link: "/finance",
    icon: <PaymentsIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 4,
    name: "About us",
    link: "/aboutus",
    icon: <Info sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 5,
    name: "Contact us",
    link: "/contactus",
    icon: <ContactPage sx={{ color: `${primary.main}` }} />,
  },

  {
    id: 6,
    name: "Articles",
    link: "/articles",
    icon: <DocumentScannerIcon sx={{ color: `${primary.main}` }} />,
  },
  {
    id: 7,
    name: "Turno Volt",
    link: "https://www.turnovolt.in",
    icon: <ElectricCarIcon sx={{ color: `${primary.main}` }} />,
    isExternal: true,
  },
];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Header = (props) => {
  const { window, scrollWithPage = false } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const mobile = useMobile();
  const navigate = useRouter();
  const [activeTabId, setActiveTabId] = useState(0);
  const state = useContext(Context);
  const { showWhatsappPopup } = useContext(Context);
  const { activeItemChanges } = useContext(ActiveItemValue);

  const value = state?.value;
  const handleChange = (event, newValue) => {
    let activeTab = navItems.filter((obj) => obj.id === newValue);
    activeItemChanges(newValue);

    // Handle external links
    if (activeTab[0]?.isExternal) {
      window.open(activeTab[0]?.link, "_blank", "noopener,noreferrer");
      return;
    }

    if (activeTab[0]?.link === "/articles") {
      navigate.push(activeTab[0]?.link);
      navigate.reload(activeTab[0]?.link);
    } else {
      navigate.push(activeTab[0]?.link);
    }
  };
  const handleDrawerToggle = () => {
    if (!mobileOpen) {
      sendAnalytics("ham_menu_clicked", {}, "en");
    }
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    let activeTab = navItems.filter((obj) => obj.link === navigate.pathname);
    activeItemChanges(activeTab[0]?.id);
    setActiveTabId(activeTab[0]?.id);
    // eslint-disable-next-line
  }, [navigate.pathname]);

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Box
        sx={{
          p: "8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Link 
            href="/" 
            onClick={(e) => {
              e.preventDefault();
              sendAnalytics("home_icon_clicked", {}, "en");
              navigate.push("/");
            }}
          >
            <Image
              src={imagesWEBP?.brandLogo}
              width="120"
              height="32"
              alt="Turno club logo"
              className={"image-section"}
            />
          </Link>
        </Box>
        <IconButton>
          <CloseRounded />
        </IconButton>
      </Box>
      <Divider />
      <List sx={{ textAlign: "left" }}>
        {navItems?.map((item, index) => {
          return (
            <React.Fragment key={index}>
              <Link 
                href={item.link} 
                underline="none"
                target={item.isExternal ? "_blank" : "_self"}
                rel={item.isExternal ? "noopener noreferrer" : undefined}
                onClick={(e) => {
                  // Don't prevent default for external links
                  if (!item.isExternal) {
                    e.preventDefault();
                    let payload = {
                      option_selected: item.name,
                      vehicle_id: "",
                      vehicle_name: "",
                    };
                    console.log("payload", payload);
                    sendAnalytics("ham_menu_option_selected", payload, "en");
                    navigate.push(item.link);
                  } else {
                    let payload = {
                      option_selected: item.name,
                      vehicle_id: "",
                      vehicle_name: "",
                    };
                    console.log("payload", payload);
                    sendAnalytics("ham_menu_option_selected", payload, "en");
                  }
                }}
              >
                <ListItem
                  style={{ padding: "6px 14px" }}
                  key={index}
                  disablePadding
                >
                  <ListItemButton
                    sx={{
                      textAlign: "left",
                      color: `${value === item.id ? "#024670" : "black"}`,
                      background: "#f7f7f7",
                      padding: "6px 14px",
                      maxWidth: "164px",
                      margin: "0px 0px 10px 10px",
                      width: "fit-content",
                      borderRadius: "8px",
                    }}
                  >
                    {item.icon}
                    <ListItemText
                      sx={{ ml: "16px", fontSize: "14px" }}
                      primary={item.name}
                    />
                  </ListItemButton>
                </ListItem>
              </Link>
            </React.Fragment>
          );
        })}

        <Link 
          href="/articles" 
          underline="none"
          onClick={(e) => {
            e.preventDefault();
            let payload = {
              option_selected: "Articles",
              vehicle_id: "",
              vehicle_name: "",
            };
            sendAnalytics("article_clicked", payload, "en");
            navigate.push("/articles");
          }}
        >
          <ListItem
            style={{ padding: "6px 14px", cursor: "pointer" }}
            key={"Articles"}
            disablePadding
          >
            <ListItemButton
              sx={{
                textAlign: "left",
                color: `${value === 7 ? "#024670" : "black"}`,
                background: "#f7f7f7",
                padding: "6px 14px",
                maxWidth: "164px",
                margin: "0px 0px 8px 10px",
                width: "fit-content",
                borderRadius: "8px",
              }}
            >
              <DocumentScannerIcon sx={{ color: `${primary.main}` }} />
              <ListItemText
                sx={{ ml: "16px", fontSize: "14px" }}
                primary={"Articles"}
              />
            </ListItemButton>
          </ListItem>
        </Link>

        <Link
          href="https://www.turno.club/brand-store"
          target="_self"
          rel="noreferrer"
          underline="none"
        >
          <ListItem
            style={{ padding: "6px 14px" }}
            key={"Showroom"}
            href="https://www.turno.club/brand-store"
            disablePadding
            onClick={() => {
              let payload = {
                option_selected: "Showroom",
                vehicle_id: "",
                vehicle_name: "",
              };
              sendAnalytics("brand_store_clicked", payload, "en");
            }}
          >
            <ListItemButton
              sx={{
                textAlign: "left",
                color: `${value === 7 ? "#024670" : "black"}`,
                background: "#f7f7f7",
                padding: "6px 14px",
                maxWidth: "164px",
                margin: "0px 0px 8px 10px",
                width: "fit-content",
                borderRadius: "8px",
              }}
            >
              <StoreIcon sx={{ color: `${primary.main}` }} />
              <ListItemText
                sx={{ ml: "16px", fontSize: "14px" }}
                primary={"Showroom"}
              />
            </ListItemButton>
          </ListItem>
        </Link>
        {/* <Link
          href="https://game.turno.club/"
          target="_self"
          rel="noreferrer"
          underline="none"
        >
          <ListItem
            key={"Play & Earn"}
            href="https://game.turno.club/"
            disablePadding
            onClick={() => {
              let payload = {
                option_selected: "Play & Earn",
                vehicle_id: "",
                vehicle_name: "",
              };
              sendAnalytics("play_and_earn_clicked", payload, "en");
            }}
          >
            <ListItemButton
              sx={{
                textAlign: "left",
                color: `${value === 7 ? "#024670" : "black"}`,
                background: "#f7f7f7",
                padding: "6px 14px",
                maxWidth: "164px",
                margin: "0px 0px 21px 10px",
                width: "fit-content",
                borderRadius: "8px",
              }}
            >
              <ToysIcon sx={{ color: `${primary.main}` }} />
              <ListItemText
                sx={{ ml: "16px", fontSize: "14px" }}
                primary={"Play & Earn"}
              />
            </ListItemButton>
          </ListItem>
        </Link> */}
      </List>
    </Box>
  );

  let height = "64px";
  return (
    <CustomAppBar elevation={0} scrollWithPage={scrollWithPage}>
      {mobile ? <MemoizedWhatsAppDrawer /> : <MemoizedWhatsAppPopup />}

      <Box
        sx={{
          display: "flex",
          minHeight: { xs: height, md: "74px" },
          justifyContent: "space-between",
        }}
      >
        <AppBar component="nav" {...(scrollWithPage ? { position: "static" } : {})}>
          <Toolbar
            sx={{
              width: "100%",
              justifyContent: "space-between",

              minHeight: {
                xs: "64px",
                md: "74px",
              },
              background: "white",
            }}
          >
            <Box
              sx={{
                display: { sm: "none", xs: "flex" },
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
              }}
            >
              <Box style={{ width: "120px" }}>
                <Link 
                  href="/" 
                  onClick={(e) => {
                    e.preventDefault();
                    sendAnalytics("home_icon_clicked", {}, "en");
                    navigate.push("/");
                  }}
                >
                  <Image
                    src={imagesWEBP?.brandLogo}
                    fill="true"
                    alt="Turno club logo"
                    className={"image-section"}
                  />
                </Link>
              </Box>
              <Box className="icons-mobile">
                <WhatsAppIcon
                  sx={{
                    marginRight: "0.5em",
                    color: "white",
                    padding: "2px",
                    borderRadius: "50%",
                    background: "#35BF68",
                  }}
                  onClick={() => {
                    leadActions("CLICK_WHATSAPP_CHAT");
                    showWhatsappPopup();
                    createCookieInHour(
                      "lead_trigger",
                      "navbar_whatsapp_chat",
                      10
                    );
                    sendAnalytics("whatsapp_header_icon_clicked", {}, "en");
                  }}
                  fontSize="large"
                />
                <Link
                  href="tel:08047482233"
                  hrefLang={"en"}
                  target="_blank"
                  rel="noreferrer"
                  underline="none"
                  onClick={() => {
                    leadActions("CLICK_WHATSAPP_CHAT");
                    createCookieInHour(
                      "lead_trigger",
                      "Phone_Call_Initiated",
                      10
                    );
                    sendAnalytics("phone_call_initiated", {}, "en");
                  }}
                >
                  <MemoizedButton
                    className="phone-icon"
                    sx={{
                      background: "#35BF68",
                      boxShadow: "none",
                      border: "none",
                      borderRadius: "50px",
                      padding: "8px",
                      marginRight: "20px",
                      fontSize: "12px",
                      "&:hover": {
                        background: "#35BF68",
                        border: "none",
                        color: "white",
                        boxShadow: "none",
                      },
                    }}
                    content={"Call Turno"}
                    endIcon={
                      <PhoneInTalkIcon
                        sx={{
                          color: "white",
                          marginRight: "2px",
                        }}
                      />
                    }
                  />
                </Link>

                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                >
                  <MenuIcon
                    sx={{
                      color: primary.main,
                    }}
                  />
                </IconButton>
              </Box>
            </Box>

            <Grid
              container
              spacing={2}
              sx={{
                display: { xs: "none", sm: "flex" },
                minHeight: { xs: "64px", md: "74px" },
                alignItems: "center",
              }}
            >
              <Grid
                item
                md={2}
                onClick={() => {
                  sendAnalytics("home_icon_clicked", {}, "en");
                  navigate.push("/");
                  activeItemChanges(0);
                }}
              >
                <Box style={{ width: "150px" }}>
                  <Image
                  //   src={
                  //     "data:image/webp;base64,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"
                    fill="true"
                    alt="Turno club logo"
                  src ={imagesWEBP?.brandLogo}
                    className={"image-section"}
                    effect="opacity"    
                  />
                </Box>
              </Grid>

              <Grid item md={10}>
                <Tabs
                  value={activeTabId}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  sx={{
                    minHeight: { xs: "64px", md: "74px" },
                    alignItems: "center",
                  }}
                >
                  {navItems?.map((items, index) => {
                    return (
                      <Tab
                        key={index}
                        value={index}
                        component={Link}
                        href={items.link}
                        target={items.isExternal ? "_blank" : "_self"}
                        rel={items.isExternal ? "noopener noreferrer" : undefined}
                        onClick={(e) => {
                          if (!items.isExternal) {
                            e.preventDefault();
                            handleChange(e, index);
                          }
                        }}
                        className={
                          activeTabId === items?.id
                            ? "navItems active"
                            : "navItems"
                        }
                        label={`${items.name}`}
                        {...a11yProps(index)}
                      />
                    );
                  })}
                  {/* <ListItem
                    key="Articles"
                    onClick={(event) => {
                      event.preventDefault();
                      const payload = {
                        option_selected: "Articles",
                        vehicle_id: "",
                        vehicle_name: "",
                      };
                      sendAnalytics("article_clicked", payload, "en");
                      navigate.push("/articles",undefined,{ locale: 'en' } );
                    }}
                  >
                    <Typography
                      style={{
                        padding: "16px",
                        background: primary.main,
                        color: primary.white,
                        fontWeight: "900",
                        borderRadius: "8px",
                        fontSize: "16px",
                      }}
                    >
                      Articles
                    </Typography>
                  </ListItem> */}

                </Tabs>

                {/*  */}
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>

        <Box component="nav">
          <Drawer
            // container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                borderRadius: "0px 20px 20px 0px",
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
      </Box>
    </CustomAppBar>
  );
};

export const MemoizedHeader = React.memo(Header);
